import { GetNextEventType } from '../../enum/get-next-event-type';
import {
  CallContactEvent,
  MuteEvent,
  UpdatePermissionsEvent,
  AgentSessionEndEvent,
  AgentSessionStartEvent,
  CXoneIndicator,
  AgentStateEvent,
  UpdateUnavailableCodeEvent,
  AgentLegEvent
} from '@nice-ccf/common-sdk';
import { AgentSessionManager } from '../agent/session/agent-session-manager';

export type AdapterEvents =
  | CallContactEvent
  | MuteEvent
  | UpdatePermissionsEvent
  | AgentSessionEndEvent
  | AgentSessionStartEvent;

/**
 * This class will handle all the get next event response according to event type
 */
export class CXoneGetNextAdapter {
  private agentSession: AgentSessionManager = AgentSessionManager.instance;

  /**
   * Used to re route the get next response based on the different event types and returns the array of processed object
   * @param events- array of get next response with different event type
   * @example
   */
  public handleGetNextResponse(events: Array<{ [key: string]: string }>) {
    events.forEach((event) => {
      switch (event.Type) {
        case GetNextEventType.CALL_CONTACT_EVENT: {
          const callContactEvent = new CallContactEvent();
          callContactEvent.parse(event);
          this.agentSession.callContactEventSubject.next(callContactEvent);
          break;
        }
        case GetNextEventType.MUTE_EVENT: {
          const muteEvent = new MuteEvent();
          muteEvent.parse(event);
          this.agentSession.muteEventSubject.next(muteEvent);
          break;
        }
        case GetNextEventType.UPDATE_PERMISSIONS_EVENT: {
          const updatePermissions = new UpdatePermissionsEvent();
          updatePermissions.parse(event);
          this.agentSession.updatePermissionsEventSubject.next(updatePermissions);
          break;
        }
        case GetNextEventType.AGENT_SESSION_START_EVENT: {
          const agentSessionStartEvent = new AgentSessionStartEvent();
          agentSessionStartEvent.parse(event);
          this.agentSession.agentSessionStartSubject.next(agentSessionStartEvent);
          break;
        }
        case GetNextEventType.AGENT_SESSION_END_EVENT:
        case GetNextEventType.REMOTE_AGENT_SESSION_END_EVENT: {
          const agentSessionEndEvent = new AgentSessionEndEvent();
          agentSessionEndEvent.parse(event);
          this.agentSession.agentSessionEndSubject.next(agentSessionEndEvent);
          break;
        }
        case GetNextEventType.AGENT_STATE_EVENT: {
          const agentStateEvent = new AgentStateEvent();
          agentStateEvent.parse(event);
          this.agentSession.agentStateSubject.next(agentStateEvent);
          break;
        }
        case GetNextEventType.UPDATE_UNAVAILABLE_CODE_EVENT: {
          const unavailableCodeEvent = new UpdateUnavailableCodeEvent();
          unavailableCodeEvent.parse(event);
          this.agentSession.agentUpdateUnavailableCodeSubject.next(unavailableCodeEvent);
          break;
        }
        case GetNextEventType.AGENT_LEG_EVENT: {
          const agentLegEvent = new AgentLegEvent();
          agentLegEvent.parse(event);
          this.agentSession.agentLegSubject.next(agentLegEvent);
          break;
        }
        case GetNextEventType.UPDATE_INDICATORS:
          this.agentSession.agentIndicatorsSubject.next();
          break;
        case GetNextEventType.INDICATOR: {
          const indicator = new CXoneIndicator();
          indicator.parse(event);
          this.agentSession.contactIndicatorsSubject.next(indicator);
          break;
        }
      }
    });
  }
}
